var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 110,
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.99 59.6162C111.199 68.4301 108.196 75.5143 103.455 83.3036C95.2715 96.7668 83.5132 103.818 69.6319 107.432C50.6468 112.367 31.8268 110.902 16.6916 96.7227C6.92407 87.5783 0.104403 75.8668 0.00540833 61.9959C-0.0605883 52.2455 0.445386 42.0324 3.30524 32.8439C7.23204 20.218 18.4075 13.288 29.2529 6.54538C44.2232 -2.76431 58.7754 -1.54136 73.8007 6.42421C82.8972 11.2498 91.2347 16.6373 98.2084 24.4376C107.294 34.5956 111.001 46.3402 110.99 59.6162Z",
    fill: "#C6D8C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69L69 41",
    stroke: "#1B4D47",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69L41 41",
    stroke: "#1B4D47",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.e3ed557633ac7c5c4d779e710a77ebd0.svg";
export { ForwardRef as ReactComponent };